import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PROJECTS } from "../../data/content";
import { Reveal, Eyebrow } from "../motion";

const ProjectCard = ({ project, className = "", ratio = "aspect-[4/3]" }) => (
  <Link
    to={`/realisations?projet=${project.id}`}
    data-testid={`realisation-card-${project.id}`}
    className={`group relative block overflow-hidden bg-card ${className}`}
  >
    <div className={`${ratio} w-full overflow-hidden`}>
      <img
        src={project.cover}
        alt={`${project.name} — ${project.type} : ${project.concept}`}
        className="h-full w-full object-cover transition-transform duration-[1.4s] group-hover:scale-[1.05]"
      />
    </div>
    <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/10 to-transparent" />
    <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 p-6 lg:p-8">
      <div>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neon">{project.type}</p>
        <h3 className="mt-2 font-serif text-2xl text-cream sm:text-3xl">{project.name}</h3>
        <p className="mt-1 text-xs text-white/50">{project.location}</p>
      </div>
      {project.rating && <p className="shrink-0 font-mono text-xs text-neon-light">★ {project.rating}</p>}
      <ArrowRight className="h-5 w-5 shrink-0 text-neon opacity-0 transition-all duration-300 group-hover:translate-x-1 group-hover:opacity-100" />
    </div>
  </Link>
);

const FEATURED = ["la-caliente", "pomme-d-amour", "hakuna-lodge", "utopia"].map((id) => PROJECTS.find((p) => p.id === id));

export const RealizationsPreview = () => (
  <section id="realisations-preview" className="py-24 lg:py-36" data-testid="section-realisations-preview">
    <div className="mx-auto max-w-[1500px] px-6 sm:px-10 lg:px-16">
      <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
        <div>
          <Reveal>
            <Eyebrow>Réalisations</Eyebrow>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-6 max-w-2xl font-serif text-4xl leading-[1.08] text-cream sm:text-5xl lg:text-6xl">
              Des projets qui ne ressemblent à aucun autre.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.16}>
          <p className="max-w-sm text-sm leading-relaxed text-white/50">
            Nos créations et celles de nos clients : suites romantiques, hébergements immersifs et familiaux,
            univers à thème et locations courte durée.
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid gap-6 lg:grid-cols-12">
        <Reveal className="lg:col-span-7">
          <ProjectCard project={FEATURED[0]} ratio="aspect-[16/10]" />
        </Reveal>
        <Reveal delay={0.08} className="lg:col-span-5">
          <ProjectCard project={FEATURED[1]} ratio="aspect-[16/10] lg:aspect-auto lg:h-full" />
        </Reveal>
        <Reveal className="lg:col-span-5">
          <ProjectCard project={FEATURED[2]} ratio="aspect-[16/10] lg:aspect-auto lg:h-full" />
        </Reveal>
        <Reveal delay={0.08} className="lg:col-span-7">
          <ProjectCard project={FEATURED[3]} ratio="aspect-[16/10]" />
        </Reveal>
      </div>

      <Reveal delay={0.1}>
        <div className="mt-12 flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-center">
          <Link to="/realisations" data-testid="realisations-preview-link" className="btn-outline">
            Voir toutes les réalisations <ArrowRight className="h-4 w-4" />
          </Link>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/35">
            Plusieurs de nos suites sont distinguées « Coup de cœur voyageurs »
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
